import type { NextPage } from "next";
import type { SVGProps } from "react";

import { ColorMain } from "@/types/styles/designSystemEnum";

interface Props extends SVGProps<SVGSVGElement> {
  stroke?: string;
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ProfileIcon: NextPage<Props> = ({
  fill = "currentColor",
  stroke = ColorMain.BLACK_MAIN,
  from,
  to,
  gradientId = "AccountProfileGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_dd_10195_128420)">
        <circle cx="60" cy="60" r="50" fill={stroke} />
        <path
          d="M60.0333 110C48.6758 110.008 37.6542 106.148 28.7823 99.0571C19.9105 91.9659 13.7172 82.0657 11.2218 70.9857C8.72643 59.9057 10.0776 48.3063 15.053 38.0965C20.0284 27.8868 28.3315 19.6751 38.5957 14.8132C48.8599 9.95115 60.4736 8.72852 71.5253 11.3465C82.577 13.9645 92.408 20.267 99.4004 29.2168C106.393 38.1667 110.13 49.2304 109.997 60.5872C109.863 71.9439 105.867 82.9168 98.6667 91.7C93.9802 97.4164 88.0846 102.023 81.4043 105.187C74.724 108.351 67.4252 109.995 60.0333 110ZM60.0333 16.6667C51.4628 16.6667 43.0848 19.2082 35.9587 23.9697C28.8325 28.7312 23.2784 35.4989 19.9986 43.4171C16.7188 51.3352 15.8607 60.0481 17.5327 68.4539C19.2047 76.8597 23.3318 84.581 29.3921 90.6413C35.4523 96.7016 43.1736 100.829 51.5794 102.501C59.9853 104.173 68.6982 103.315 76.6163 100.035C84.5344 96.755 91.3021 91.2008 96.0637 84.0747C100.825 76.9486 103.367 68.5705 103.367 60C103.367 48.5073 98.8012 37.4853 90.6746 29.3587C82.548 21.2322 71.5261 16.6667 60.0333 16.6667Z"
          fill={fill}
        />
        <path
          d="M60.0293 63.3242C56.0737 63.3242 52.2069 62.1512 48.9179 59.9536C45.6289 57.756 43.0655 54.6324 41.5517 50.9779C40.038 47.3234 39.6419 43.302 40.4136 39.4224C41.1853 35.5428 43.0901 31.9791 45.8872 29.1821C48.6842 26.385 52.2479 24.4802 56.1275 23.7085C60.0071 22.9368 64.0284 23.3329 67.683 24.8466C71.3375 26.3604 74.461 28.9238 76.6587 32.2128C78.8563 35.5018 80.0293 39.3686 80.0293 43.3242C80.0293 48.6285 77.9221 53.7156 74.1714 57.4663C70.4207 61.2171 65.3336 63.3242 60.0293 63.3242ZM60.0293 29.9909C57.3922 29.9909 54.8143 30.7729 52.6217 32.238C50.429 33.703 48.7201 35.7854 47.7109 38.2218C46.7017 40.6581 46.4377 43.339 46.9522 45.9254C47.4666 48.5118 48.7365 50.8876 50.6012 52.7523C52.4659 54.617 54.8417 55.8869 57.4281 56.4013C60.0145 56.9158 62.6954 56.6518 65.1317 55.6426C67.5681 54.6334 69.6505 52.9245 71.1155 50.7318C72.5806 48.5392 73.3626 45.9613 73.3626 43.3242C73.3626 39.788 71.9579 36.3966 69.4574 33.8961C66.9569 31.3956 63.5655 29.9909 60.0293 29.9909Z"
          fill={fill}
        />
        <path
          d="M60.0319 59.9974C69.2366 59.9974 76.6986 52.5355 76.6986 43.3307C76.6986 34.126 69.2366 26.6641 60.0319 26.6641C50.8272 26.6641 43.3652 34.126 43.3652 43.3307C43.3652 52.5355 50.8272 59.9974 60.0319 59.9974Z"
          fill={fill}
        />
        <path
          d="M60.0502 109.996C52.6584 109.991 45.3596 108.347 38.6793 105.183C31.999 102.018 26.1034 97.4122 21.4169 91.6959L19.6836 89.5625L21.4169 87.4625C26.1073 81.7536 32.0046 77.1551 38.6847 73.9979C45.3648 70.8406 52.6616 69.2031 60.0502 69.2031C67.4389 69.2031 74.7356 70.8406 81.4157 73.9979C88.0958 77.1551 93.9932 81.7536 98.6835 87.4625L100.417 89.5625L98.6835 91.6959C93.9971 97.4122 88.1015 102.018 81.4212 105.183C74.7409 108.347 67.4421 109.991 60.0502 109.996ZM28.4169 89.5958C32.471 93.9359 37.374 97.3963 42.8215 99.7621C48.2689 102.128 54.1446 103.349 60.0836 103.349C66.0226 103.349 71.8982 102.128 77.3457 99.7621C82.7931 97.3963 87.6961 93.9359 91.7502 89.5958C87.6961 85.2558 82.7931 81.7954 77.3457 79.4296C71.8982 77.0637 66.0226 75.8429 60.0836 75.8429C54.1446 75.8429 48.2689 77.0637 42.8215 79.4296C37.374 81.7954 32.471 85.2558 28.4169 89.5958Z"
          fill={fill}
        />
        <path
          d="M23.957 89.6055C23.957 89.6055 57.5237 127.105 91.6903 93.3388L96.0903 89.6055C96.0903 89.6055 67.557 60.0055 38.5904 77.7722L23.957 89.6055Z"
          fill={fill}
        />
      </g>
      <defs>
        <filter
          id={gradientId}
          x="-8"
          y="-4"
          width="136"
          height="136"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10195_128420"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_10195_128420"
            result="effect2_dropShadow_10195_128420"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_10195_128420"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ProfileIcon;
